import React from 'react';

const filters = ( props ) => {
   const specialtyInputs = props.specialties.map((specialty) => (
      <option key={specialty} value={specialty}>{specialty}</option>
   ));
   return (

      <div class="news_filter">
         <div class="search">
            <i class="fas fa-search"></i>
            <input placeholder="SEARCH" type="text" value={props.filterName} onChange={props.nameChange} />
         </div>
         <div class="divider"></div>
         <div class="category">
           <div class="feed_select">
              <select onChange={props.specialtyClick}>
                 <option value="">Specialty</option>
                 {specialtyInputs}
              </select>
            </div>
         </div>
      </div>

   );

};

export default filters;



// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js